import { DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import {
  Component, inject, OnInit, signal,
} from '@angular/core';

import {
  ButtonComponent,
  DropdownOption,
  ModalComponent,
  SelectFieldComponent,
  TextAreaFieldComponent,
  TextFieldComponent,
} from '@instaclause-webapp/shared-ui';
import { TranslocoModule } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';

import { ContractModelGroupsClient, ContractModelsClient } from '../../../core/api/api.service';

@Component({
  selector: 'app-new-contract-model',
  providers: [
    ContractModelsClient,
    ContractModelGroupsClient,
  ],
  imports: [
    CommonModule,
    ButtonComponent,
    ModalComponent,
    TextFieldComponent,
    TextAreaFieldComponent,
    SelectFieldComponent,
    TranslocoModule,
  ],
  templateUrl: './new-contract-model.component.html',
  styleUrl: './new-contract-model.component.scss',
})
export class NewContractModelComponent implements OnInit {

  contractModelName = signal<string>('');
  introductionText = signal<string>('');
  modelGroupId = signal<number>(NaN);
  groupsOptions = signal<DropdownOption[]>([]);

  saving = signal<boolean>(false);

  private dialogRef = inject(DialogRef);
  private contractModelService = inject(ContractModelsClient);
  private modelGroupsService = inject(ContractModelGroupsClient);

  private languageId = 1;

  ngOnInit(): void {
    this.setModelGroup();
  }

  async onSave() {
    this.saving.set(true);
    if (!this.contractModelName()) {
      return;
    }

    const contractModelResponse = await firstValueFrom(
      this.contractModelService.create({
        name: this.contractModelName(),
        introductionText: this.introductionText(),
        groupId: this.modelGroupId(),
        languageId: this.languageId,
      })
    );

    if (!contractModelResponse || typeof contractModelResponse.contractModelId !== 'number') {
      return;
    }

    this.saving.set(false);

    const { contractModelId } = contractModelResponse;

    this.dialogRef.close(contractModelId);
  }

  onClose() {
    this.dialogRef.close();
  }

  private async setModelGroup() {
    const response = await firstValueFrom(this.modelGroupsService.get(this.languageId));
    const groups = response.contractModelGroups;
    this.groupsOptions.set(groups.map(v => ({ label: v.name, value: v.groupId })));
    this.modelGroupId.set(this.groupsOptions()[0].value as number);
  }
}
